module.exports = __webpack_public_path__ + "static/media/LISTEN-1.79c300e0.svg";